export { TabContent } from './tab-content.js';
export { TabIndicator } from './tab-indicator.js';
export { TabList } from './tab-list.js';
export { TabTrigger } from './tab-trigger.js';
export { TabsContext } from './tabs-context.js';
export { TabsRoot } from './tabs-root.js';
export { TabsRootProvider } from './tabs-root-provider.js';
export { useTabs } from './use-tabs.js';
export { useTabsContext } from './use-tabs-context.js';
import * as tabs from './tabs.js';
export { tabs as Tabs };
export { anatomy as tabsAnatomy } from '@zag-js/tabs';
